export default __webpack_public_path__ + "static/tula-553d460f2288f535bd07209624b7f202.webp";